$( document ).ready(function() {
    if(document.getElementById('contenido_generar_documento')){
        tinyMCE.baseURL = `${url_base}/js/tinymce`;
        tinyMCE.init({
            height : "45vh",
            selector: '#contenido_generar_documento',
            theme_url: `${url_base}/js/tinymce/themes/silver/theme.min.js`,
            language_url : `${url_base}/js/tinymce/langs/es.js`,
            language: 'es',
            plugins: [
                'lists',
                'link',
                'searchreplace',
                'charmap',
                'autolink',
                'code',
                'table',
                'paste',
                'image',
                'wordcount',
                'insertdatetime',
                'visualblocks',
                'advlist'
            ],
            toolbar: 'undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | print media | forecolor backcolor',
        });
    }
});
$( document ).ready(function() {
    if(document.getElementById('documento_generado')){
        setTimeout(function(){
            $("#modalPrevisualizarDocumento").modal('show');
            previewDocumento(document.getElementById('documento_generado').value);
        },300);
    }
});

previewDocumento = function(id){
    axios.get(url_base+'/documentos/'+id+'/stream/pdf',{
        _token: token.content
    })
    .then(response => {
        if(response.data.preview){
            $("#modalPrevisualizarDocumento").modal('show');
            document.getElementById('previsualizar_documento_div').innerHTML=response.data.preview;
        }
    })
    .catch(e => {
        console.log(e);
    });
}
eliminarDocumento = function(id){
    $("#modalEliminarDocumento").modal('show');
    $("#eliminar_documento_id").val(id);
}

previewConsulta = function(e,tipo='stream'){
    let data = e.dataset;
    let id = data.id;
    axios.get(url_base+'/documentos/consultas/'+id+'/'+tipo,{
        _token: token.content
    })
    .then(response => {
        if(response.data.preview){
            console.log(response);
            document.getElementById('previsualizar_documento_div').innerHTML=response.data.preview;
            setTimeout(function(){
                $("#modalPrevisualizarDocumento").modal('show');
            },300);
        }
    })
    .catch(e => {
        console.log(e);
    });
}